export default {
  id: 'behavioral-profile',
  title: 'Behavioral Profile',
  content: `## Behavioral Profile

Your Behavioral Profile is a label that describes how you trade — based on your actual decision patterns, not a questionnaire.

It is built automatically from your ACT sessions and live paper trades. It updates as you trade more, reflecting your most recent 30–60 days of behaviour.

---

## Where to Find It

**Profile → Trader Personality**

---

## The Four Profiles

### Disciplined Executor

**Signal:** Consistent planning, stop loss adherence, R:R above 2.0, low revenge trade count.

You follow your rules. You define your trade before entering, exit when your stop is hit, and do not chase setups. This is the profile to aspire to.

What to watch: Overconfidence — disciplined traders sometimes take lower-quality setups because their process feels automatic.

---

### Methodical Analyser

**Signal:** High plan completeness, tendency to Wait rather than Enter, above-average setup quality scores but lower trade frequency.

You are thorough but sometimes over-analytical. You miss good setups by waiting for certainty that never comes. Your decisions are well-reasoned but your conviction to act on them is inconsistent.

What to watch: Paralysis — good analysis with no execution produces no results. At some point a setup is good enough.

---

### Impulsive Trader

**Signal:** Low plan completeness, frequent trades without defined stops, R:R often below 2.0, decisions cluster around FOMO and momentum chasing.

You react to price movement instead of following a plan. You enter when something is moving and exit when it feels uncomfortable — not when your plan says to.

What to watch: Every trade needs a defined stop and target before entry. Remove the option to wing it.

---

### Overconfident Buyer

**Signal:** High conviction ratings on low-quality setups, frequent entries against trend or at extended levels (RSI overbought + price far above SMA20), revenge trading after losses.

You trust your instincts more than the data. You mark setups as HIGH conviction even when the signals do not support it. After a loss, you tend to increase size to recover faster.

What to watch: Let the setup quality score, not your gut, determine conviction.

---

## How the Profile is Assigned

TradeLab analyses the last 30–60 trading sessions and maps your decision signals to the closest label. The assignment is not a hard threshold — multiple traits can overlap. The label shown is the dominant pattern.

The profile updates automatically. If your behaviour improves over 30 days, the label will shift.

---

## Using Your Profile

Your profile shapes the coaching language Nyx uses when reviewing your setups. It also appears in your Trade Reports as context for interpreting your P&L and decision history.`,
};
